module.exports = __webpack_public_path__ + "static/img/lv-bg.d8d5e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/lv-bg.png
// module id = deHB
// module chunks = 4